import { RmaHistoryPageContext } from "@auer-steel/Pages/RmaHistoryPage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import * as React from "react";
import { connect } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({ 
        isPricingHiddenByRole: Boolean(getSettingsCollection(state).productSettings.isPricingHiddenByRole), 
    });

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export const orderTotalStyles: SearchTextFieldStyles = {};
const styles = orderTotalStyles;

const OrderHistorySearchFieldOrderTotal: React.FunctionComponent<Props> = props => {
    if(props.isPricingHiddenByRole)
    {
        return null;
    }
    return (
        <SearchTextField
            testSelector="orderHistory_filterOrderTotal"
            styles={styles}
            parameterField="orderTotal"
            label="Amount"
            inputType="number"
            placeholder=""
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderHistorySearchFieldOrderTotal),
    definition: {
        group: "Order History",
        allowedContexts: [RmaHistoryPageContext],
        displayName: "RMA Total",
    },
};

export default widgetModule;
